import React from 'react';

interface ActionButtonProps {
  onClick: () => void;
  icon: React.ComponentType<{ className?: string }>;
  variant?: 'edit' | 'delete' | 'activate' | 'deactivate';
  title?: string;
  disabled?: boolean;
}

const variantStyles = {
  edit: 'text-blue-600 hover:text-blue-900 hover:bg-blue-50',
  delete: 'text-red-600 hover:text-red-900 hover:bg-red-50',
  activate: 'text-green-600 hover:text-green-900 hover:bg-green-50',
  deactivate: 'text-red-600 hover:text-red-900 hover:bg-red-50'
};

export default function ActionButton({ 
  onClick, 
  icon: Icon, 
  variant = 'edit', 
  title, 
  disabled = false 
}: ActionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`p-2 rounded-md transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${variantStyles[variant]}`}
      title={title}
    >
      <Icon className="h-5 w-5" />
    </button>
  );
}